import React, { useEffect, useState } from 'react'
import CustomPostJobButtonToAdd from '../../../../Components/CustomPostJobButtonToAdd/CustomPostJobButtonToAdd'
import PostInternship from './PostInternship'
import actions from '../../../../ReduxStore/actions';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import PostJobViewModal from '../PostJob/PostJobViewModal';
import PostInternshipViewModal from './PostInternshipViewModal';

const PostInernshipHome = () => {
  const tableData = [
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },

  ];
  const tableHeadData = ['S.No', 'Company Name', 'Internship Type', 'Total Vacancies', 'Offers To', "Actions"]


  const dispatch = useDispatch();

  const { getInternshipsByUserId } = useSelector(state => state?.getInternshipsByUserId);
  console.log(getInternshipsByUserId?.data, "getInternshipsByUserIdgetInternshipsByUserId")
  const { addpostinternship } = useSelector(
    (state) => state?.addpostinternship
  );

  const { deleteInternshipById } = useSelector(
    (state) => state?.deleteInternshipById
  );

  const [rowTableData, setRowTableData] = useState([])
  console.log(rowTableData, "rowTableTAdatatattattat")

  const [loading, setLoading] = useState(false);
  const sessionUserId = sessionStorage.getItem("userId")


  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {

      const data1 = {
        data: {},
        method: "get",
        apiName: `getInternshipsByUserId/${sessionUserId}`,
      };

      const responseData = await dispatch(actions.GETINTERNSHIPSBYUSERID(data1));
      // if (responseData?.payload?.message === "Events Fetched successfully!") {

      // }
      console.log(responseData, "responseDataaa")
      // setResponseTableData(responseData?.payload)

    }


    fetchData();

  }, [addpostinternship, deleteInternshipById]);

  useEffect(() => {
    const tempArr = [];

    getInternshipsByUserId?.data?.map((data, index) => {
      return tempArr.push({
        id: data?.internship_id,
        company_name: data?.company_name || '--',
        internship_location: data?.internship_location || '--',
        total_vacancies: data?.total_vacancies || '--',
        // skills: data?.skills || '--',
        offered_to: data?.offered_to || '--',


      });
    });
    setRowTableData(tempArr);


  }, [getInternshipsByUserId]);

  const handleDeletePost = async (id) => {
    const data1 = {
      data: {
        user_id: Number(sessionUserId)
      },
      method: "delete",
      apiName: `deleteInternshipById/${id}`,
    };

    const responseData = await dispatch(actions.DELETEINTERNSHIPBYID(data1));
    if (responseData?.payload?.message === "Internship deleted successfully.") {
      toast.success("Internship deleted successfully.")

    }
    else {
      toast.error(responseData?.payload?.message)
    }
  }

  const handleViewModal = async (id) => {
    const data1 = {
      data: {},
      method: "get",
      apiName: `getInternshipById/${id}`,
    };

    const responseData = await dispatch(actions.GETINTERNSHIPBYID(data1));

  }


  return (
    <div>
      <CustomPostJobButtonToAdd addComponent={PostInternship} title="Internship or Graduation Project details" buttonText="Upload Internship/Graduation Projects" handleViewModal={handleViewModal} componentModalName={PostInternshipViewModal} handleDeletePost={handleDeletePost} tableData={rowTableData} tableHeadData={tableHeadData} />
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  )
}

export default PostInernshipHome